import hoist from 'hoist-non-react-statics'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

import { actions as AppActions } from '../../redux/app/redux'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import App from '../App'
import TranslationInjector from '../TranslationInjector'


const asTemplate = (WrappedComponent) => {
  const mapSelectors = () => ({
    //
  })

  const mapActions = dispatch => ({
    setLangKey: langKey => dispatch(AppActions.setLangKey(langKey)),
  })

  const decorators = [
    connect(mapSelectors, mapActions),
    memoized,
  ]

  function TemplateWrapper(props) {
    const { pageContext, location: { pathname: activeRoute }, setLangKey, data: { allContentfulDomain } } = props

    const domains = allContentfulDomain?.edges

    useEffect(() => {
      setLangKey(pageContext.langKey)
    })

    return (
      <TranslationInjector locale={pageContext.langKey}>
        <Helmet>
          <html lang={pageContext.langKey} />
        </Helmet>
        <App activeRoute={activeRoute} domains={domains}>
          <WrappedComponent {...props} />
        </App>
      </TranslationInjector>
    )
  }

  TemplateWrapper.propTypes = {
    setLangKey: PropTypes.func.isRequired,
    pageContext: PropTypes.shape({
      langKey: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }

  TemplateWrapper.WrappedComponent = WrappedComponent

  TemplateWrapper = chainDecorators(decorators, TemplateWrapper)

  return hoist(TemplateWrapper, WrappedComponent)
}

export default asTemplate
